<template>
  <div class="team">
    <p class="text-h6">チームランキング</p>
    <div>
      <v-alert
        border="left"
        colored-border
        type="info"
        elevation="2"
        style="font-size: 90%"
      >
        <ul>
          <li>ランキングは9時から21時の間、1時間に1回更新されます。タイムラグがあります。</li>
          <li>4人未満のチームは、ランキング対象外です。</li>
        </ul>
      </v-alert>
      <div class="team-ranking-table">
        <v-simple-table dense v-if="!isMobile">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">順位</th>
                <th class="text-left">チーム名</th>
                <th class="text-left">平均ポイント</th>
                <th class="text-left">人数</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="team in teamRankingList" :key="team.id">
                <td>
                  <v-icon class="mb-1" v-if="team.rank === 1" color="gold">mdi-crown</v-icon>
                  <v-icon class="mb-1" v-if="team.rank === 2" colr="silver">mdi-crown</v-icon>
                  <v-icon class="mb-1" v-if="team.rank === 3" color="bronze">mdi-crown</v-icon>
                  {{team.rank}} 位
                </td>
                <td>{{team.name}}</td>
                <td>{{team.average_point}} pt</td>
                <td>{{team.ranking_member_count}} 人</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense v-if="isMobile">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left pl-2 pr-2">順位</th>
                <th class="text-left pl-2 pr-2">チーム名</th>
                <th class="text-left pl-2 pr-2">平均ポイント</th>
                <th class="text-left pl-2 pr-2">人数</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="team in teamRankingList" :key="team.id">
                <td class="pl-0 pr-0" v-if="team.rank === 1" style="white-space: nowrap;">
                  <v-icon class="mb-1" color="gold">mdi-crown</v-icon>
                  {{team.rank}} 位
                </td>
                <td class="pl-0 pr-0" v-else-if="team.rank === 2" style="white-space: nowrap;">
                  <v-icon class="mb-1" colr="silver">mdi-crown</v-icon>
                  {{team.rank}} 位
                </td>
                <td class="pl-0 pr-0" v-else-if="team.rank === 3" style="white-space: nowrap;">
                  <v-icon class="mb-1" color="bronze">mdi-crown</v-icon>
                  {{team.rank}} 位
                </td>
                <td class="pl-2 pr-1" v-else style="white-space: nowrap;">
                  {{team.rank}} 位
                </td>
                <td class="pl-2 pr-2">{{team.name}}</td>
                <td class="pl-2 pr-2">{{team.average_point}} pt</td>
                <td class="pl-2 pr-2">{{team.ranking_member_count}} 人</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
    <div class="text-center mt-6">
      <v-progress-circular v-if="isLoading" indeterminate color="secondary" />
      <div v-if="!isLoading && teamRankingList.length === 0">
        ランキングデータがありません
      </div>
    </div>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'

const listAllTeamRankingQuery = (campaignId, limit) => `
  query listAllTeamRanking {
    listAllTeamRanking(
      campaign_id: "${campaignId}",
      limit: ${limit}
      ) {
      teams {
        id
        name
        ranking_member_count
        average_point
        rank
      }
    }
  }
`
const fetchListAllTeamRanking = async (campaignId) => {
  const { data: { listAllTeamRanking: data } } = await GraphqlAPI(listAllTeamRankingQuery(campaignId, 1000))
  return data
}

export default {
  name: 'teamRanking',
  data () {
    return {
      title: 'チームランキング',
      teamRankingList: [],
      isLoading: false
    }
  },
  computed: {
    getCampaign () {
      return this.$store.getters.getCampaign
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  async created () {
    this.isLoading = true
    try {
      this.teamRankingList = (await fetchListAllTeamRanking(this.getCampaign.id)).teams
    } catch (e) {
      this.$emit('errorHandling', 'チームランキングの取得に失敗しました。' + e.errors[0].message)
    }
    this.isLoading = false
  }
}
</script>

<style scoped lang="scss">
.team-ranking-table > .v-data-table ::v-deep th {
  border-right: 1px solid #c4c4c4 !important;
  background-color: #FFF8E1 !important;
}
.team-ranking-table > .v-data-table ::v-deep td {
  border-right: 1px solid #c4c4c4 !important;
}
.team-ranking-table > .v-data-table ::v-deep div.v-data-table__wrapper {
  border: 1px solid #c4c4c4 !important;
  border-right: 0px !important;
}
</style>
